import { useLocation } from 'react-router-dom'

const useIsMobile = (): boolean => {
  const location = useLocation()

  return location.pathname.startsWith('/mobile/')
}

export default useIsMobile
